/* YuvenLife cart discount display fix — 23.07.2026 */
(function () {
  "use strict";

  var CART_KEY = "yl-cart-id-v3";
  var syncTimer = null;
  var requestNo = 0;

  function eur(value) {
    return (Number(value) || 0).toFixed(2).replace(".", ",") + " €";
  }

  function esc(value) {
    return String(value == null ? "" : value).replace(/[&<>\"]/g, function (char) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[char];
    });
  }

  function numberFromMoney(money) {
    var value = money && money.amount != null ? parseFloat(money.amount) : 0;
    return isNaN(value) ? 0 : value;
  }

  function ensureStyles() {
    if (document.getElementById("yl-cart-discount-fix-styles")) return;
    var style = document.createElement("style");
    style.id = "yl-cart-discount-fix-styles";
    style.textContent =
      ".yl-cart-price-summary{display:grid;gap:8px;margin:12px 0 14px;width:100%;font-size:14px;line-height:1.35}" +
      ".yl-cart-price-summary__row{display:flex;justify-content:space-between;gap:18px;align-items:baseline}" +
      ".yl-cart-price-summary__row strong{font-weight:500;white-space:nowrap}" +
      ".yl-cart-price-summary__discount{color:#e85817}" +
      ".yl-cart-price-summary[hidden]{display:none!important}";
    document.head.appendChild(style);
  }

  function replaceTotalLabel(totalElement) {
    if (!totalElement) return;
    var row = totalElement.closest("[data-cart-total-row], .cart-drawer__total, .cart-total, .cart-summary__total") || totalElement.parentElement;
    if (!row) return;

    Array.prototype.slice.call(row.childNodes).forEach(function (node) {
      if (node === totalElement || (node.nodeType === 1 && node.contains(totalElement))) return;
      if (node.nodeType === 3) {
        node.nodeValue = node.nodeValue.replace(/Geschätzter Gesamtwert|Summe|Gesamtsumme/g, "Gesamt");
      } else if (node.nodeType === 1 && !node.querySelector("[data-cart-total]")) {
        var text = (node.textContent || "").trim();
        if (/^(Geschätzter Gesamtwert|Summe|Gesamtsumme)$/i.test(text)) node.textContent = "Gesamt";
      }
    });
  }

  function summaryHost(totalElement) {
    if (!totalElement) return null;
    var row = totalElement.closest("[data-cart-total-row], .cart-drawer__total, .cart-total, .cart-summary__total") || totalElement.parentElement;
    if (!row || !row.parentNode) return null;
    var summary = document.querySelector("[data-yl-cart-price-summary]");
    if (!summary) {
      summary = document.createElement("div");
      summary.setAttribute("data-yl-cart-price-summary", "");
      summary.className = "yl-cart-price-summary";
      row.parentNode.insertBefore(summary, row);
    }
    return summary;
  }

  function renderCartPricing(cart) {
    var totalElement = document.querySelector("[data-cart-total]");
    if (!totalElement || !cart || !cart.cost) return;

    var subtotal = numberFromMoney(cart.cost.subtotalAmount);
    var total = numberFromMoney(cart.cost.totalAmount);
    var discount = Math.max(0, subtotal - total);
    var activeCode = (cart.discountCodes || []).filter(function (entry) {
      return entry && entry.applicable !== false;
    })[0];

    totalElement.textContent = eur(total);
    replaceTotalLabel(totalElement);

    var summary = summaryHost(totalElement);
    if (!summary) return;

    if (activeCode && discount > 0.004) {
      summary.hidden = false;
      summary.innerHTML =
        '<div class="yl-cart-price-summary__row"><span>Zwischensumme</span><strong>' + eur(subtotal) + '</strong></div>' +
        '<div class="yl-cart-price-summary__row yl-cart-price-summary__discount"><span>Rabatt · ' + esc(activeCode.code) + '</span><strong>−' + eur(discount) + '</strong></div>';
    } else {
      summary.hidden = true;
      summary.innerHTML = "";
    }

    var status = document.querySelector("[data-discount-status]");
    if (status && activeCode) status.textContent = "";
  }

  function syncPricing() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      var cartId = null;
      try { cartId = localStorage.getItem(CART_KEY); } catch (error) {}
      if (!cartId || !window.YuvenStorefront || !window.YuvenStorefront.getCart) return;

      var currentRequest = ++requestNo;
      window.YuvenStorefront.getCart(cartId).then(function (result) {
        if (currentRequest !== requestNo) return;
        if (result && result.ok && result.cart) renderCartPricing(result.cart);
      });
    }, 80);
  }

  function init() {
    ensureStyles();
    if (window.YuvenCart && window.YuvenCart.onChange) {
      window.YuvenCart.onChange(syncPricing);
    }
    document.addEventListener("click", function (event) {
      if (event.target.closest("[data-discount-apply], [data-cart-toggle], [data-add-to-cart], [data-cart-remove]")) {
        setTimeout(syncPricing, 250);
        setTimeout(syncPricing, 900);
      }
    });
    syncPricing();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
